import { HouseBookingTypeEnum, Maybe } from '../lib/graphql'

export const isInstantOrEstimatedBookingType = (
  bookingType?: Maybe<HouseBookingTypeEnum>,
) => {
  if (!bookingType) {
    return false
  }
  return [
    HouseBookingTypeEnum.INSTANT_PRICE,
    HouseBookingTypeEnum.ESTIMATED_PRICE,
  ].includes(bookingType)
}
